import { render, staticRenderFns } from "./dialogex.vue?vue&type=template&id=13ddf63c"
import script from "./dialogex.vue?vue&type=script&lang=js"
export * from "./dialogex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports